/**
 * HarvestTimesheetsAllExportButton
 */
import React from 'react';
import { connect } from 'react-redux';

// Components
import SubmittingButton from '../../../../../../components/SubmittingButton';

// Actions
import { requestExportReportsHarvestTimesheetsAll } from '../../../../../../services/reportsHarvestTimesheetsAll/actions';

interface Props {
    requestExportReportsHarvestTimesheetsAll: Function;
}

export class HarvestTimesheetsAllExportButton extends React.PureComponent<Props> {
    handleClick = () => {
        this.props.requestExportReportsHarvestTimesheetsAll();
    };

    render() {
        return (
            <SubmittingButton
                namespace="REPORTS_HARVEST_TIMESHEETS_ALL_EXPORT"
                secondary
                circular
                size="small"
                onClick={this.handleClick}
            >
                Export
            </SubmittingButton>
        );
    }
}

export default connect(
    null,
    { requestExportReportsHarvestTimesheetsAll }
)(HarvestTimesheetsAllExportButton);
